/**
 * Nhãn tiếng Việt cho trạng thái VẬN ĐƠN phía hãng (`order.shipping.state`) —
 * KHÁC `order.state` (trạng thái đơn hàng).
 *
 * Trạng thái lạ (hãng mới, giá trị BE chưa map) phải hiện NGUYÊN VĂN ở nơi
 * gọi: nói "---" là xoá mất một thông tin có thật khỏi màn hình.
 */
export const SHIPPING_ORDER_STATE_LABELS: Record<string, string> = {
  IN_PROCESS: 'Đang xử lý',
  AWAITING_PICKUP: 'Chờ lấy hàng',
  PICKING_UP: 'Đang lấy hàng',
  IN_TRANSIT: 'Đang vận chuyển',
  DELIVERED: 'Đã giao',
  RETURNED: 'Đã hoàn',
  CANCELLED: 'Đã huỷ',
};
